import React, { useState, useEffect, useMemo, useCallback } from 'react';
import _ from 'lodash';
import { Button, UncontrolledTooltip, Tooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import CustomDataModal from '../../CustomDataModal';

export const HundredInfoTooltip = ({ id } = {}) => {
  return (
    <>
      <span id={id} className="pl-1">
        <FontAwesomeIcon icon={faInfoCircle} />
      </span>
      <UncontrolledTooltip delay={0} target={id}>
        The sum of the asset allocations must be 100 %
      </UncontrolledTooltip>
    </>
  );
};

export const selectOptions = {
  valueContainer: () => ({
    paddingLeft: 10,
    display: 'flex',
    alignItems: 'center',
  }),
  menu: () => ({
    zIndex: 200,
    position: 'absolute',
    backgroundColor: '#fff',
  }),
};

export const getSum = (nums) => {
  return parseFloat(_.sum(_.compact(nums))).toFixed(2);
};

export const isHundred = (nums) => {
  const sum = _.sum(_.compact(nums));
  return Math.round(sum * 100) / 100 === 100;
};

export const trimData = (products, databases, weights, expectedReturns, minWeights, maxWeights, groups) => {
  const result = products.reduce(
    (acc, prod, i) => {
      if (prod && weights[i]) {
        acc.products.push(prod);
        acc.databases.push(databases[i]);
        acc.weights.push(weights[i]);
        acc.expectedReturns.push(expectedReturns[i]);
        acc.minWeights.push(minWeights[i]);
        acc.maxWeights.push(maxWeights[i]);
        acc.groups.push(groups[i]);
      }
      return acc;
    },
    { products: [], databases: [], weights: [], expectedReturns: [], minWeights: [], maxWeights: [], groups: [] },
  );

  return result;
};

export const DEFAULT_PORTFOLIO_1 = 'Portfolio #1';
export const defaultNulls = [null, null, null, null, null];
export const defaultZeros = [0, 0, 0, 0, 0];
export const defaultHundreds = [100, 100, 100, 100, 100];
export const defaultGroups = Array(defaultZeros.length).fill('Group 1');

export function CopyPortfolioButton({ onClose, isMulti }) {
  const [showCustomDataModal, setShowCustomDataModal] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    <>
      <Button
        id="copy-portfolio"
        className="btn"
        color="info"
        onClick={() => {
          setShowCustomDataModal(true);
        }}
      >
        Copy Portfolio
      </Button>
      <Tooltip placement="top" isOpen={tooltipOpen} target="copy-portfolio" toggle={toggle}>
        Copy and paste your tickers and allocations
      </Tooltip>
      {showCustomDataModal && (
        <CustomDataModal
          isOpen
          isMulti={isMulti}
          onClose={(data) => {
            onClose(data);
            setShowCustomDataModal(false);
          }}
        />
      )}
    </>
  );
}

export function parseNumericValue(strval, min = 0, max = 100) {
  const num = parseFloat(strval);
  if (isNaN(num)) return 0;

  const clamped = Math.min(Math.max(num, min), max);
  return parseFloat(clamped.toFixed(2));
}

export function percentToFloat(value) {
  const num = parseFloat(value);
  if (isNaN(num)) return 0;
  return parseFloat((num / 100).toFixed(2));
}

export function zipToObject(keys, values, mapper) {
  if (!Array.isArray(keys) || !Array.isArray(values)) {
    console.warn('zipToObject: Both inputs must be arrays.');
    return {};
  }

  if (keys.length !== values.length) {
    console.warn('zipToObject: Arrays must be of the same length.');
    return {};
  }

  return keys.reduce((obj, key, i) => {
    obj[key] = mapper ? mapper(values[i]) : values[i];
    return obj;
  }, {});
}
